import { CheckoutRoutes } from '../../pages'

export default CheckoutRoutes
